import * as React from 'react'
function SvgCurrencyCredit(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M24 14c.8 0 1.4.4 1.8 1l6.6 12c1 2 1 4.2 0 6-1.2 1.8-3 3-5.2 3H12.8c-2.2 0-4-1.2-5.2-3-1-1.8-1-4.2 0-6l6.6-12c.4-.6 1-1 1.8-1zm2-10c2 0 2.4 2.2 1.4 3.4l-2 2c-.4.4-.8.6-1.4.6h-8c-.6 0-1-.2-1.4-.6l-2-2C11.4 6.2 12 4 14 4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgCurrencyCredit
